import { FlashmeetingLogo } from 'components/icons/logos/flashmeeting_logo.component';
import { PlaniteamLogo } from 'components/icons/logos/planiteam_logo.component';
import { KamishibaiLogo } from 'components/icons/logos/kamishibai_logo.component';
import { ResolutionLogo } from 'components/icons/logos/resolution_logo.component';
import { APPS_NAME } from '@umanforge/common';

export const VERSION: string = '1.10.0';

export const APPS_INFOS = {
  Flashmeeting: {
    name: `${APPS_NAME.FLASHMEETING}`,
    color: '#FA4616',
    icon: <FlashmeetingLogo size={ 40 } />,
  },
  Kamishibai: {
    name: `${APPS_NAME.KAMISHIBAI}`,
    color: '#00abc4',
    icon: <KamishibaiLogo size={ 40 } />
  },
  Resolution: {
    name: `${APPS_NAME.RESOLUTION}`,
    color: '#45D52E',
    icon: <ResolutionLogo size={ 40 } className='p-[2px]' />
  },
  Planiteam: {
    name: `${APPS_NAME.PLANITEAM}`,
    color: '#3b82f6',
    icon: <PlaniteamLogo size={ 40 } className='p-[2px]' />
  }
};